import {Translation} from 'primeng/api';

export const translations: Translation = {
    monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio',
        'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
    monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug',
        'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    equals: 'Uguale',
    contains: 'Contiene',
    noFilter: 'Nessun filtro',
    notEquals: 'Diverso',
    notContains: 'Non contiene',
    startsWith: 'Inizia per',
    endsWith: 'Termina per',
    gt: 'Maggiore di',
    gte: 'Maggiore o uguale a',
    lt: 'Minore di',
    lte: 'Minore o uguale a'
};
